import axios from "axios";

export const downloadFileWithName = async (downloadUrl, fileName) => {
    if (!downloadUrl) return;
    try {
        const response = await axios({
            url: downloadUrl,
            method: 'GET',
            responseType: 'blob',
        });
        const blob = new Blob([response.data], { type: response.headers['content-type'] || 'application/octet-stream' });
        const link = document.createElement('a');
        const url = window.URL.createObjectURL(blob);
        link.href = url;
        
        let finalFileName = fileName || 'documento';
        // Ensure filename retains its proper extension
        if (!finalFileName.includes('.')) {
            const ext = downloadUrl.split('.').pop().split('?')[0];
            if (ext && ext.length < 5) {
                finalFileName = `${finalFileName}.${ext}`;
            }
        }

        link.setAttribute('download', finalFileName);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
    } catch (error) {
        console.error("Error downloading file with custom name:", error);
        const link = document.createElement('a');
        link.href = downloadUrl;
        link.setAttribute('download', fileName || 'documento');
        link.target = '_blank';
        document.body.appendChild(link);
        link.click();
        link.remove();
    }
};

export const downloadFile = async (downloadUrl, fileType = 'application/pdf') => {
    const response = await axios({
        url: downloadUrl,
        method: 'GET',
        responseType: 'blob',
    });
    const file = new Blob([response.data], { type: fileType });
    return URL.createObjectURL(file);
};